import { PaletteOptions } from '@mui/material';
import { orange } from '@mui/material/colors';
import { coral, grey, red, green, blue } from './palettes';

const contrastText = '#fff';
const textPrimary = '#111113';
const textSecondary = '#0372b3';
const textDisabled = 'rgba(0, 0, 10, 0.26)';

const paletteOptions: PaletteOptions = {
  primary: {
    light: coral[200],
    main: coral[400],
    dark: coral[600],
    contrastText,
  },
  secondary: {
    light: blue[200],
    main: blue[400],
    dark: blue[700],
    contrastText,
  },
  tertiary: {
    light: grey['A700'],
    main: grey['A400'],
    dark: grey[900],
    contrastText,
  },
  error: {
    light: red[400],
    main: red[600],
    dark: red[800],
    contrastText,
  },
  success: {
    light: green[500],
    main: green[800],
    dark: green[900],
    contrastText,
  },
  warning: {
    main: '#ED6C02',
    light: orange[500],
    dark: orange[900],
  },
  grey,
  contrastThreshold: 3,
  tonalOffset: 0.2,
  text: {
    primary: textPrimary,
    secondary: textSecondary,
    disabled: textDisabled,
  },
  divider: '#dddddf',
  background: {
    paper: '#fff',
    default: '#fff',
    image: '#f2f2f4',
    table: '#f9f9fb',
    input: '#fafafc',
  },
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  },
  border: {
    primary: '#dddddf',
    secondary: '#e9e9eb',
    tertiary: '#f3f3f5',
    selected: 'rgba(4, 136, 214, 0.5)',
    input: '#eeeeef',
  },
  icon: {
    primary: coral[400],
    secondary: blue[700],
    tertiary: grey['A400'],
    textPrimary: '#111113',
    textSecondary: textSecondary,
    contrast: '#fff',
  },
};

export default paletteOptions;
